// Classificação de BLOQUEIO da origem a partir do status HTTP do stream.
//
// Contexto (perf/tv-zapping, jul/26): antes, o Provider fazia um
// `fetch HEAD` SEQUENCIAL antes de todo `player.load()` só pra descobrir se
// a origem estava bloqueando (geo/ToS). Custava 240-434ms em CADA troca de
// canal na LG real — e era redundante: o GET do próprio stream devolve o
// mesmo status, e o player agora propaga isso em `PlayerErrorPayload.httpStatus`
// (mpegts `NetworkError`/`HttpStatusCodeInvalid`; Shaka `BAD_HTTP_STATUS`).
//
// Regra pura pra ser testável — a UI depende dela pra escolher entre
// "conteúdo bloqueado" e "falha ao reproduzir" (PlayerScreen/MobilePlayer
// leem `error.code === 'blocked'`).

/**
 * Status que significam "a origem NEGOU", não "a rede falhou".
 *
 * - 403: Forbidden (geo-block genérico — o caso comum em CDN)
 * - 410: Gone (recurso descontinuado)
 * - 451: Unavailable For Legal Reasons (RFC 7725)
 * - 503: Service Unavailable (overload; tratado como bloqueio, igual ao
 *        pre-check antigo — preserva o comportamento que a UI já tinha)
 */
export const BLOCKED_HTTP_STATUS = [403, 410, 451, 503]

/**
 * `indexOf` (ES5) em vez de `includes`/`Set`: o piso de compat do pacote de
 * TV é Chromium antigo (`Array.prototype.includes` só existe a partir do
 * Chr47). Ver o gate de compat em docs/specs/ui-tier.md.
 */
export function isBlockedStatus(status: number | undefined): boolean {
  if (status === undefined) return false
  return BLOCKED_HTTP_STATUS.indexOf(status) !== -1
}
